import { Span, Text } from "@clipboard-health/ui-components";
import { CardContent, Link } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";
import { useZendeskArticle } from "@src/appV2/Zendesk/useZendeskArticle";

import { useWorkerToWorkplaceAffiliateExperiment } from "../hooks/useWorkerToWorkplaceAffiliateExperiment";
import { WorkplaceReferralAction, WorkplaceReferralComponent } from "../types";
import { getWorkerToWorkplaceVariantName } from "../utils/getWorkerToWorkplaceVariantName";
import { WorkplaceReferralCard } from "./WorkplaceReferralCard/WorkplaceReferralCard";

interface ReferralPolicyProps {
  referralCode: string;
}

export function ReferralPolicy(props: ReferralPolicyProps) {
  const { referralCode } = props;
  const isWorkerToWorkplaceAffiliateProgramEnabled = useWorkerToWorkplaceAffiliateExperiment();
  const { referralPolicySupportLink } = useSupportLinks();
  const { openArticle } = useZendeskArticle();

  return (
    <WorkplaceReferralCard>
      <CardContent>
        <Text>
          <Span sx={{ verticalAlign: "middle" }}>
            {isWorkerToWorkplaceAffiliateProgramEnabled
              ? "Read our Affiliate Program Policy"
              : "Read our Workplace Referrals Policy"}
          </Span>{" "}
          <Link
            component="button"
            onClick={async () => {
              logEvent(APP_V2_USER_EVENTS.WORKPLACE_REFERRAL, {
                action: WorkplaceReferralAction.REFERRAL_POLICY_CLICKED,
                component: WorkplaceReferralComponent.REFERRAL_POLICY_SECTION,
                variant: getWorkerToWorkplaceVariantName(
                  isWorkerToWorkplaceAffiliateProgramEnabled
                ),
                referralCode,
              });
              await openArticle(referralPolicySupportLink);
            }}
          >
            here.
          </Link>
        </Text>
      </CardContent>
    </WorkplaceReferralCard>
  );
}
